export const formatDisplay = "DD/MM/YYYY";
export const formatPrint = "DD/MM/YY";
export const formatDatabase = "YYYYMMDD";
